export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7273.af41d7f9.jpg";